import {
  collection,
  addDoc,
  getDocs,
  getDoc,
  doc,
  updateDoc,
  query,
  orderBy,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "./config";

const ORDERS_COLLECTION = "orders";

// ─── Create new order ─────────────────────────────────────────────────────────
export const createOrder = async (orderData) => {
  const docRef = await addDoc(collection(db, ORDERS_COLLECTION), {
    ...orderData,
    status: "pending",
    createdAt: serverTimestamp(),
  });
  return docRef.id;
};

// Add this to your existing orderService.js
export const confirmOrder = async (id) => {
  const docRef = doc(db, ORDERS_COLLECTION, id);
  await updateDoc(docRef, {
    status: "paid",
    paidAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
};

// ─── Get all orders (admin only) ──────────────────────────────────────────────
export const getAllOrders = async () => {
  const q = query(
    collection(db, ORDERS_COLLECTION),
    orderBy("createdAt", "desc"),
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

// ─── Get single order ─────────────────────────────────────────────────────────
export const getOrderById = async (id) => {
  const docRef = doc(db, ORDERS_COLLECTION, id);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return { id: docSnap.id, ...docSnap.data() };
  }
  return null;
};

// ─── Update order status (admin only) ────────────────────────────────────────
export const updateOrderStatus = async (id, status) => {
  const docRef = doc(db, ORDERS_COLLECTION, id);
  await updateDoc(docRef, {
    status,
    updatedAt: serverTimestamp(),
  });
};
